module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k2z75"))).then(() => module.bundle.root('2KbAe'));